<template>
  <div class="shadow-blue-sm rounded bg-white p-3">
    <h5 class="d-flex align-items-center mb-5">
      <span class="material-icons mr-2">shopping_cart</span>
      {{ products.length ? "Productos" : "Servicios" }}
    </h5>
    <div
      v-for="product in products"
      :key="product._id._id"
      class="row mb-2 product"
    >
      <div class="col-lg-3">
        <div
          class="img-fluid img-thumbnail img-squared mr-4 border mx-sm-auto"
          :style="`background-image: url('${url_base}public/images/products/${product._id.images[0]}'); height: 8em; width: 8em;`"
        ></div>
      </div>
      <div class="col-lg-6 d-flex align-items-center">
        <div class="mx-sm-auto">
          <h5>{{ product._id.name }}</h5>
          <p>{{ getOpt(product) }}</p>
        </div>
      </div>
      <div class="col-lg-1 d-flex align-items-center">
        <h5 class="mx-sm-auto">{{ product.amount }}</h5>
      </div>
      <div class="col-lg-2 d-flex align-items-center">
        <h5 class="text-danger mx-sm-auto">
          SC${{ product.price.toFixed(2) }}
        </h5>
      </div>
    </div>
    <div
      v-for="service in services"
      :key="service._id._id"
      class="row mb-2 product"
    >
      <div class="col-lg-3">
        <div
          class="img-fluid img-thumbnail img-squared mr-4 border mx-sm-auto"
          :style="`background-image: url('${url_base}public/images/services/${service._id.images[0]}'); height: 8em; width: 8em;`"
        ></div>
      </div>
      <div class="col-lg-6 d-flex align-items-center">
        <h5 class="mx-sm-auto">{{ service._id.name }}</h5>
      </div>
      <div class="col-lg-1 d-flex align-items-center">
        <h5 class="mx-sm-auto">{{ service.amount }}</h5>
      </div>
      <div class="col-lg-2 d-flex align-items-center">
        <h5 class="text-danger mx-sm-auto">
          SC${{ service.price.toFixed(2) }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import Configs from "../../configs/configs";
export default {
  name: "ProductsDetail",
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    services: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      url_base: Configs.API.BASE,
    };
  },
  methods: {
    getOpt(product) {
      if (!product.options.length) return "";

      let ret = "";
      for (const option of product.options) {
        ret += ` [${option.name}: ${option.value}]`;
      }
      return ret;
    },
  },
};
</script>